/* eslint-disable import/no-anonymous-default-export */
import { api } from "./apiServices";

export const uploadPicture = (token, data) => api(token).post("/company/upload-picture", data).then(handleResponse);
export const updateProfile = (token, data) => api(token).post("/company/update-profile", data).then(handleResponse);
export const updatePassword = (token, data) => api(token).post("/company/password-update", data).then(handleResponse);
export const getKeys = (token, data) => api(token).post("/company/get-keys", data).then(handleResponse);
export const createKeys = (token, data) => api(token).post("/company/create-key-request", data).then(handleResponse);
export const getDashboardData = (token) => api(token).get("/company/get-dashboard-data").then(handleResponse);

const handleResponse = (response) => {
  let data = response.data;
  if (response.data.code == 6) {
    localStorage.removeItem("token");
    window.location.href = "/login";
  }
  return data;
};
